<template>
  <div class="auth-debug">
    <v-container class="auth-debug__container">
      <v-row justify="end">
        <v-col class="auth-debug__column">
          <v-btn
            @click="subtract1Min"
            rounded
            elevation="0"
            class="auth-debug__button"
            :disabled="subtractDisabled"
            :text="subtractDisabled"
            >{{ subtractDisabled ? 'Session Expired' : '-1 min' }}</v-btn
          >
        </v-col>
        <v-col class="auth-debug__column">
          <div class="auth-debug__timer">{{ timeRemaining }}</div>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col class="auth-debug__column">
          <v-btn @click="renewToken" rounded elevation="0" class="auth-debug__button"
            >Renew Access Token</v-btn
          > </v-col
        ><v-col class="auth-debug__column">
          <span class="auth-debug__token-expiry">{{ accessTokenExpiryDate }}</span>
        </v-col></v-row
      ></v-container
    >
  </div>
</template>

<script>
export default {
  name: 'AuthDebug',
  data() {
    return {
      lastActivityTime: 0,
      timeRemaining: '0:00',
      accessTokenExpiry: null,
    };
  },
  computed: {
    subtractDisabled: function () {
      return this.timeRemaining === '0:00';
    },
    accessTokenExpiryDate: function () {
      if (this.accessTokenExpiry) {
        return this.accessTokenExpiry.toLocaleTimeString();
      }
    },
  },
  methods: {
    subtract1Min: function (event) {
      event.stopPropagation();
      const lastActivityTime = parseInt(localStorage.getItem('lastActivityTime'));
      const newActivityTime = lastActivityTime - 60000;
      if(this.$logger && typeof(this.$logger)!=='undefined'){
        this.$logger.debug(
          'Modify Last Activity Time: ' +
            new Date(lastActivityTime).toLocaleTimeString() +
            ' => ' +
            new Date(newActivityTime).toLocaleTimeString()
        );
      }
      localStorage.setItem('lastActivityTime', newActivityTime);
      this.getTimeRemaining();
    },
    renewToken: function (event) {
      // Set a session Storage var to be used on the implicit callback only when the user was still authenticated - only the TOKEN expired
      // this has to be per tab as multiple tab  could try to rediect to different path...
      if (typeof Storage !== 'undefined' && typeof(window)!='undefined') {
        // get the path from the Query
        if(this.$logger && typeof(this.$logger)!=='undefined'){
          this.$logger.debug(JSON.stringify(window.location.pathname));
        }
        sessionStorage.setItem(
          'implicitCallbackRedirect',
          JSON.stringify(window.location.pathname)
        );
      }

        // this will redirect to OKTA - use prompt none to make sure we are not getting stuck on OKTA login page...
      this.$auth.oktaAuth.token.getWithRedirect({prompt: 'none'});
    },
    getTimeRemaining: async function () {
      const self = this;
      this.lastActivityTime = localStorage.getItem('lastActivityTime');

      if (!this.lastActivityTime || !(await this.$auth.isAuthenticated())) {
        return '0:00';
      }

      const now = Date.now();

      const timeDifference = parseInt(this.lastActivityTime) + 600000 - now;
      if (!timeDifference || timeDifference < 0) {
        this.timeRemaining = '0:00';
        return;
      }
      this.timeRemaining = `${Math.floor(timeDifference / 60000)}:${Math.abs(
        Math.round(Math.floor(timeDifference / 1000) % 60)
      )
        .toString()
        .padStart(2, '0')}`;

      this.$auth.getAccessToken().then((val) => {
        if (val) {
          self.accessTokenExpiry = new Date(
            parseInt(self.$auth.oktaAuth.token.decode(val).payload.exp.toString() + '000')
          );
        }
      });
    },
  },
  mounted: function () {
    const self = this;
    setInterval(function () {
      self.getTimeRemaining();
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.auth-debug {
  position: sticky;
  bottom: 20px;
  align-items: flex-end;
  text-align: right;
  padding-right: 20px;
  display: inline-block;
  border-radius: 20px;
  background-color: white;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);

  &__container {
    padding: 0 !important;
  }

  &__column {
    align-self: center;
  }

  &__timer {
    padding: 0 15px 0 10px;
  }

  &__token-expiry {
    width: 100%;
  }
}
</style>